import { coreApiBaseUrl } from '@consigli/hooks';
import { getSessionFromStorage } from '@consigli/oauth';
import i18n from 'i18next';

type TranslationData = {
  [key: string]: string;
};

const languageCodeToLanguage = (languageCode: string): string => {
  switch (languageCode) {
    case 'en':
    case 'en-GB':
    case 'en-US':
      return 'en';
    case 'de':
      return 'de';
    case 'es':
      return 'es';
    case 'fr':
      return 'fr';
    case 'ja':
      return 'ja';
    case 'nb':
    case 'no-NB':
      return 'nb';
    case 'nn':
    case 'no-NN':
      return 'nn';
    case 'sv':
      return 'sv';
    case 'vi':
      return 'vi';
    case 'ca':
      return 'ca';
    case 'zh':
      return 'zh';
    default:
      return 'nb';
  }
};

export const fetchMessageTemplates = async (lng: string, ns: string) => {
  const language = languageCodeToLanguage(lng);

  try {
    const token = getSessionFromStorage();
    if (!token) {
      throw new Error('No token');
    }

    const response = await fetch(`${coreApiBaseUrl}/locales/${language}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token.idToken.token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const translations: TranslationData = await response.json();
    i18n.addResources(lng, ns, translations);
  } catch (error) {
    console.error('Error loading findings', error);
  }
};
